import BoldSmallText from '@/components/BoldSmallText';
import { PlanMessage } from '@/components/PlanMessage';
import RegularText from '@/components/RegularText';
import { COLOR_SCHEME_OPTIONS, PricingPlan } from '@/constants/enum';
import { handleSaveWidgetSettings, widgetAppearanceDisableSelector, widgetSettingSelector } from '@/redux/slice/widget.slice';
import { BlockStack, InlineStack, RadioButton } from '@shopify/polaris';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

export const ColorPalettes = () => {
  const { t } = useTranslation('widget_settings');
  const dispatch = useDispatch();
  const widgetSettings = useSelector(widgetSettingSelector);
  const widgetAppearanceDisable = useSelector(widgetAppearanceDisableSelector);

  return (
    <BlockStack gap={'100'}>
      <BoldSmallText>{t('widgetDesign.colorPalette.title')}</BoldSmallText>
      <RadioButton
        label={t('widgetDesign.colorPalette.light')}
        checked={widgetSettings.colorScheme === COLOR_SCHEME_OPTIONS.LIGHT}
        id="light-color"
        name="light-color"
        onChange={() => dispatch(handleSaveWidgetSettings({ colorScheme: COLOR_SCHEME_OPTIONS.LIGHT }))}
      />
      {/* <RadioButton
        label={t('widgetDesign.colorPalette.dark')}
        id="dark-color"
        name="dark-color"
        checked={widgetSettings.colorScheme === COLOR_SCHEME_OPTIONS.DARK}
        onChange={() => dispatch(handleSaveWidgetSettings({ colorScheme: COLOR_SCHEME_OPTIONS.DARK }))}
      /> */}
      <InlineStack gap="200" align="space-between" blockAlign="center">
        <RadioButton
          label={<RegularText>{t('widgetDesign.colorPalette.custom')}</RegularText>}
          id="custom-color"
          name="custom-color"
          checked={widgetSettings.colorScheme === COLOR_SCHEME_OPTIONS.CUSTOM}
          onChange={() => dispatch(handleSaveWidgetSettings({ colorScheme: COLOR_SCHEME_OPTIONS.CUSTOM }))}
          disabled={widgetAppearanceDisable.isDisableCustomStyle}
        />
        {widgetAppearanceDisable.isDisableCustomStyle && <PlanMessage plan={PricingPlan.Essential} />}
      </InlineStack>
    </BlockStack>
  );
};
